<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        style="margin-bottom: 5px;"
        
        @click="getDate()"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px;margin-bottom: 5px;"
        @click="select()"
        >筛选</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;margin-bottom: 5px;"
        @click="applyCount()"
        >待审核 {{count || 0}}</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px;margin-bottom: 5px;"
        >导出</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        v-if="wrCheckSuccess"
        style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
        @click="checkSuccessList()"
        >批量审核通过</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        v-if="wrCheckReject"
        style="margin-left: 10px;background:#FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
        @click="checkRejectList()"
        >批量审核拒绝</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="width: 44px">状态</label>
        <el-select v-model="checkStatus" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="未审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核异常" value="2"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">提币地址</label>
        <el-input
          v-model="address"
          placeholder="请输入提币地址"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">ip</label>
        <el-input
          v-model="ip"
          placeholder="请输入ip"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">国家地区</label>
        <el-input
          v-model="ipAddress"
          placeholder="请输入国家地区"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>

      <div class="item_warp">
        <label style="margin: 0 10px">乙方</label>
        <el-input
          v-model="yifangUsername"
          placeholder="请输入乙方"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">时间</label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="content">
      <div class="head_search" style="margin-bottom: 0px;">
        <div class="item_warp">
          <label style="margin: 0 10px">自动通过条件（全部满足）：实际到账金额小于:</label>
          <el-input v-model="active.shLessAmount" placeholder="请输入到账金额" style="width: 80px" size="mini" clearable/>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">累计充值金额大于</label>
          <el-input v-model="active.shMoreRecharge" placeholder="请输入到账金额" style="width: 80px" size="mini" clearable/>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">VIP:</label>
          <el-radio-group style="display: flex;" v-model="active.shRequiredVipLevel">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">单用户每天自动通过次数上限:</label>
          <el-input v-model="active.shCountLimit" placeholder="请输入到账金额" style="width: 140px" size="mini" clearable/>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px"></label>
          <el-checkbox v-model="active.isMoreWithdraw">总充值 > 总提现</el-checkbox>
        </div>
      </div>
      <div class="" style="display: flex;align-items: center;">
        <div class="item_warp">
          <label style="margin: 0 10px">自动审核设置:</label>
          <el-checkbox v-model="active.shIsEnableZhuan">开启</el-checkbox>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px"></label>
          <el-button
        type="success"
        size="mini"
        style="background:#6663FF;border:none"
        @click="updateAutoShenhe()"
        >保存</el-button
      >
        </div>
      </div>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <div style="color: red">
          <span>实际总提现：{{ amount || 0 }}  </span>
          <!-- <span style="margin-left: 10px">提现手续费：{{ chargeFee || 0 }}</span> -->
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1991px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" :selectable="checkSelectable"/>
      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <div>
            <div
              class=""
              v-if="scope.row.checkStatus != 1 && scope.row.checkStatus != 2"
            >
                <el-button
                type="primary"
                class="edit-button"
                style="background: #06cc00; border: none"
                size="mini"
                @click="memberTiePass(scope.row)"
                >通过</el-button
              >
                <el-button
                type="primary"
                class="edit-button"
                style="background: #ff0000; border: none"
                size="mini"
                @click="memberTieReject(scope.row)"
                >拒绝</el-button
              >
            </div>
            <div v-if="scope.row.checkStatus == 1" style="color: #06cc00">审核通过</div>
            <div v-if="scope.row.checkStatus == 2" style="color: #ff0000">审核拒绝</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="memberUid" label="用户" width="100" />
      <el-table-column prop="amount" label="提现金额" width="100" />
      <el-table-column prop="address" label="实际到账" width="100">
        <template slot-scope="scope">
          <div style="font-size: 18px;font-weight: 700;color: red;">
            {{ scope.row.reachAmount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="金额详情" width="160">
        <template slot-scope="scope">
          <div>
            <div>提现前：{{ scope.row.beforeAmount }}</div>
            <div>提现后：{{ scope.row.afterAmount }}</div>
            <div>手续费：{{ (Number(scope.row.chargeFee)+Number(scope.row.platformFee)).toFixed(4) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="手续费模式" width="100">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.chargeType == 0">单笔固定</div>
            <div v-if="scope.row.chargeType == 1">按提现金额比例</div>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column prop="address" label="审核时间" width="170">
        <template slot-scope="scope">
          <div> 
            <div v-if="scope.row.checkStatus == 1">{{scope.row.checkPassDate?happenTimeFun(scope.row.checkPassDate):''}}</div>
            <div v-if="scope.row.checkStatus == 2">{{scope.row.checkRejectDate?happenTimeFun(scope.row.checkRejectDate):''}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="提币地址" width="150" />
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="totalRecharge" label="累计充值" width="100" />
      <el-table-column prop="totalWithdraw" label="累计提现" width="100" />
      <el-table-column prop="vipLevel" label="会员等级" width="100">
        <template slot-scope="scope">
          <div>
            VIP{{scope.row.vipLevel}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="yifangUsername" label="乙方" width="100" />
      <el-table-column prop="adminUsername" label="审核操作管理员" width="120" />
      <el-table-column prop="ip" label="IP" width="150">
        <template slot-scope="scope">
          <div>
            <div>{{scope.row.ip}}</div>
            <div>{{scope.row.ipAddress}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加
      uid: "",
      address: "",
      ipAddress: "",
      checkStatus: "",
      ip: "",
      yifangUsername: "",
      dataTime: ["", ""],
      amount: "",
      chargeFee: "",
      active: {},
      count:0,
      wrCheckReject:false,
      wrCheckSuccess:false
    };
  },
  mounted() {
    this.$api.user
        .getInfo()
        .then((res) => {
          console.log(res)
          if(res.adminInfoVo.authorities[0] == 'admin:*'){
            this.wrCheckReject = true
            this.wrCheckSuccess = true

          }else{
            res.adminInfoVo.permissions.forEach(item => {
            if(item == 'permission:wrCheckRejectList'){
              this.wrCheckReject = true
            }
            if(item == 'permission:wrCheckSuccessList'){
              this.wrCheckSuccess = true
            }

          })

          }
          
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
       
    this.getDate();
    this.autoShenhe()
  },
  methods: {
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    // 自动审核设置 更新接口：
    updateAutoShenhe(){
      this.$api.operate
        .updateAutoShenhe(this.active)
        .then((res) => {
          this.$message.success(res);
          this.autoShenhe()
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
          this.autoShenhe()
        })
        .finally(() => {
          this.loading = false;
          this.autoShenhe()
        });
    },
    // 自动审核设置 回显接口：
    autoShenhe(){
      this.$api.operate
        .autoShenhe()
        .then((res) => {
          this.active = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkSelectable(row) {
      if(row.checkStatus == 0){
        return true
      }else{
        return false
      }
    },
    // 审核通过
    memberTiePass(row){
        this.$confirm("是否通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      this.$api.operate
        .checkSuccess({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
    },
    // 审核不通过
    memberTieReject(row){
        this.$confirm("是否不通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      this.$api.operate
        .checkReject({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
    },
    // 批量审核通过
    checkSuccessList(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .checkSuccessList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })
    },
    // 批量审核不通过
    checkRejectList(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .checkRejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
    },
    applyCount(){
      this.checkStatus = '0'
      this.select()
    },
    getApplyCount(){
      this.$api.operate
        .applyCount()
        .then((res) => {
          this.count = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
      this.totalRecharge();
      this.getApplyCount()
    },
    getDate() {
      this.getList();
      this.totalRecharge();
      this.getApplyCount()

    },
    totalRecharge() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        checkStatus: this.checkStatus,
        address: this.address,
        ipAddress: this.ipAddress,
        ip: this.ip,
        yifangUsername: this.yifangUsername,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .totalAmount(params)
        .then((res) => {
          this.amount = res.amount;
          this.chargeFee = res.chargeFee;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        checkStatus: this.checkStatus,
        address: this.address,
        ipAddress: this.ipAddress,
        ip: this.ip,
        yifangUsername: this.yifangUsername,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .withdrawRecordList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.content {
  border: 2px dashed #000;
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
</style>
